// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/mf-area-definition.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/mf-area-definition/mf-area-definition.js';
import g1 from '../lessons/air-law/mf-area-definition/mf-uncontrolled.js';

mount([g0, g1]);
